<template>

    <!--    @keydown.esc="!showProgressBar ? closeAdminOptionsDialog() : ''"
        @click:outside="!showProgressBar ? closeAdminOptionsDialog() : ''"-->

    <v-dialog
        v-model="$props.params.adminOptionsDialog"
        transition="dialog-bottom-transition"
        max-width="600px"
        @keydown.esc="closeAdminOptionsDialog()"
        @click:outside="closeAdminOptionsDialog()"
        :persistent="showProgressBar"
    >
        <v-card>
            <v-toolbar color="primary" dark :class="dialogHeadingClasses()">
                <v-icon v-text="icons.mdiTune" class="mr-3"></v-icon>
                {{ $gettext('Admin Options') }}
                <v-spacer></v-spacer>
                <!--                v-show="!showProgressBar"-->
                <v-icon class="mr-2" @click.native.stop="closeAdminOptionsDialog()" v-text="icons.mdiClose"
                        :title="$gettext('Close')"></v-icon>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-container>
                    <v-form class="my-0 py-0">

                        <alert type="info"
                               :text="$gettext('Please note: The following are actions, and they are executed immediately.')"></alert>

                        <v-list-item :disabled="(showCircularLoadingForTlsFilter() === 'primary') || !isTlsApplicable">
                            <v-list-item-content>
                                <v-list-item-title class="text-left">Turn on/off TLS filter</v-list-item-title>
                                <v-list-item-subtitle class="text-left"
                                                      v-if="!isTlsApplicable && typeof showCircularLoadingForTlsFilter() === 'boolean'">
                                    Currently, TLS is not applicable for you
                                </v-list-item-subtitle>
                                <v-list-item-subtitle class="text-left" v-else>This will instantly turn on/off the tls
                                    filter
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-switch
                                    v-model="tlsFilter" :true-value="true" :false-value="false"
                                    :loading="showCircularLoadingForTlsFilter()" @change="updateTlsFilter($event)"/>
                            </v-list-item-action>
                        </v-list-item>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions color="secondary">
                <v-spacer></v-spacer>
                <v-btn class="primary" @click.native.stop="closeAdminOptionsDialog()"
                       v-text="$gettext('Close')"></v-btn>
            </v-card-actions>
        </v-card>
        <snackbar ref="snackbar"></snackbar>

    </v-dialog>
</template>
<style type="text/scss">

.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import MixinAdminOptions from '@/mixins/MixinAdminOptions'

export default {
    name: 'DialogAdminOptions',
    mixins: [MixinAdminOptions, MixinDialog, MixinIcon, MixinStringManipulation, MixinGenericComponent],
    props: {
        params: {
            required: true,
            type: Object | Array,
        },
    },
    data() {
        return {}
    },
    methods: {

        closeAdminOptionsDialog() {
            let self = this
            let appComponent = self.genericComponentGetComponent('App')
            appComponent.closeDialog('adminOptionsDialog')
        },

        tlsNotInstalled(option) {
            return (option && option.hasOwnProperty('key') && (option.key === 'tlsfilter') && option.hasOwnProperty('value') && typeof option.value?.status === 'string'
                && option.value?.status?.toLowerCase().includes('not installed'))
        }

    },

}
</script>
